import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "order-package-input" }
const _hoisted_2 = {
  key: 0,
  class: "order-package-input__container"
}
const _hoisted_3 = { class: "order-package-input__button__container" }

import TextButton from '@/components/input/Btn/TextButton.vue';
import { i18n } from '@/i18n';
import NumberInput from '@/orderCalendarModule/components/NumberInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderPackageInputPopUp',
  props: {
    popUpState: { type: Boolean },
    modelValue: {}
  },
  emits: ["update:modelValue", "close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;
const props = __props;

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "order-package-input__outside",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
    }, null, 512), [
      [_vShow, _ctx.popUpState]
    ]),
    (_ctx.popUpState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(NumberInput, {
            "model-value": _ctx.modelValue,
            label: _unref(t)('発注単位(詳細ページ)'),
            placeholder: _unref(t)('発注単位'),
            "has-border": true,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = (e) => emits('update:modelValue', e))
          }, null, 8, ["model-value", "label", "placeholder"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(TextButton, {
              "button-style": 'btn-secondary',
              size: 'btn-ss',
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('close')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
              ], undefined, true),
              _: 1
            }),
            _createVNode(TextButton, {
              "button-style": 'btn-primary',
              size: 'btn-ss',
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('confirm')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('変更')), 1)
              ], undefined, true),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})